module.exports = __webpack_public_path__ + "img/image1.202f11c2.jpg";